import { blake2b } from "@noble/hashes/blake2b.js";

export function blake2b256(data: Uint8Array): string {
  return Buffer.from(blake2b(data, { dkLen: 32 })).toString("hex");
}
